import React from 'react';
import useMediaQuery from "@mui/system/useMediaQuery";
import {useTheme} from "@mui/joy";
import Dialog from "@mui/material/Dialog";
import {
    addCategoriesToAttributes,
    BasicModalContent,
    sortAttributes,
} from "@dreebit-registry/vsm-microservice-components";
import {resolveErrorMessage} from "../../utils/resolveErrorMessage";
import {InstalledBaseNode} from "../../codegen/graphql";
import NodeModalTitle from "./NodeModalTitle";
import {useTranslation} from "react-i18next";
import {useMutation, useQuery} from "@apollo/client";
import {toast} from "react-toastify";
import _ from "lodash";
import {
    AddInstalledBaseNodeToInstalledBaseAccessGroup
} from "../../graphql/mutations/addInstalledBaseNodeToInstalledBaseAccessGroup";
import {InstalledBaseAccessGroupListTdas} from "../../graphql/queries/installedBaseAccessGroupListTdas";
import InstalledBaseTDAForm from "../InstalledBaseTDAForm";

interface Props {
    node: InstalledBaseNode;
    open: boolean,
    onClose?: () => void,
}


const NodeAccessModal = ({node, onClose, open}: Props) => {
    const theme = useTheme();
    const isFullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const {t} = useTranslation();

    const [addNodeToAccessGroupMutation] = useMutation(AddInstalledBaseNodeToInstalledBaseAccessGroup);


    const {data} = useQuery(InstalledBaseAccessGroupListTdas, {
        variables: {
            tdaActionKey: "INSTALLED_BASE_NODE_ADD_ACCESS_GROUP"
        },
        fetchPolicy: "network-only",
    })

    const attributes = _.get(data, 'installedBaseAccessGroupList.typeDefinitionAttributeList.typeDefinitionAttributes', [])

    const groupedAttributes = addCategoriesToAttributes(attributes, {'read': ['Access rights'], 'write': ['Access rights']})

    const sortedAttributes = sortAttributes(groupedAttributes, ['installedBaseAccessGroup'])

    const handleSubmit = (input: any) => {
        return addNodeToAccessGroupMutation({
                variables: {
                    installedBaseNodeId: node?.id,
                    accessGroupId: input.installedBaseAccessGroup,
                    input: {
                        read: input.read,
                        write: input.write,
                    },
                },
                // TODO @JonnyAccess: Access node list refetchen für alle nodes
                refetchQueries: []
            }
        ).then((res) => {
            if (res.data?.addInstalledBaseNodeToInstalledBaseAccessGroup?.success && res.data?.addInstalledBaseNodeToInstalledBaseAccessGroup?.message) {
                toast.success(res.data.addInstalledBaseNodeToInstalledBaseAccessGroup.message);
            } else {
                toast.error(t("Error setting access for this node."))
            }
            if (onClose) {
                onClose();
            }
        }).catch((err) => {
            toast.error(resolveErrorMessage(err, t))
        })
    }


    return <Dialog open={open} onClose={onClose} fullScreen={isFullScreen}>
        <BasicModalContent
            title={<NodeModalTitle prefix={t('Set group access for')} node={node} labelType={'title'}/>}
            onClose={onClose}
        >
            <InstalledBaseTDAForm
                formStyle={{paddingTop: '0px'}}
                onSubmit={handleSubmit}
                onCancel={onClose}
                submitButtonText={t('Set access')}
                attributes={sortedAttributes}
            />
        </BasicModalContent>
    </Dialog>
};

export default NodeAccessModal;
